import { Flame, Zap, Heart, Activity, Leaf, Brain } from "lucide-react";
import { useEmailCapture } from "../components/EmailCaptureProvider";

export const Benefits = () => {
  const { openModal } = useEmailCapture();
  
  const benefits = [
    {
      icon: <Flame className="text-[#FF6B00]" size={28} />,
      title: "Turbocharge Metabolism",
      description: "Citrus aurantium activates thermogenesis, turning your body into a 24/7 fat-burning machine.",
    },
    {
      icon: <Zap className="text-[#FF6B00]" size={28} />,
      title: "All-Day Energy",
      description: "No crashes, no jitters. Experience clean, sustained energy from morning to night.",
    },
    {
      icon: <Heart className="text-[#FF6B00]" size={28} />,
      title: "Crush Cravings",
      description: "Natural appetite support helps you say goodbye to late-night snacking and emotional eating.",
    },
    {
      icon: <Brain className="text-[#FF6B00]" size={28} />,
      title: "Mental Clarity",
      description: "Feel sharper and more focused throughout your day with improved cognitive function.",
    },
    {
      icon: <Activity className="text-[#FF6B00]" size={28} />,
      title: "Healthy Blood Sugar",
      description: "Support balanced blood sugar levels for consistent energy and reduced fat storage.",
    },
    {
      icon: <Leaf className="text-[#FF6B00]" size={28} />,
      title: "100% Natural",
      description: "Plant-based, non-GMO, soy-free, dairy-free. No artificial ingredients ever.",
    },
  ];

  return (
    <section id="benefits" data-testid="benefits-section" className="py-16 md:py-20 bg-white" aria-labelledby="benefits-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div onClick={openModal} className="cursor-pointer">
          <div className="text-center mb-12">
            <span className="inline-block bg-[#FFF5E6] text-[#FF6B00] text-xs font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              Powerful Benefits
            </span>
            <h2 id="benefits-heading" className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1A1C19] mb-4" style={{ fontFamily: "Fraunces, serif" }}>
              What The <span className="text-[#FF6B00]">"Orange Peel Trick"</span> Does For You
            </h2>
            <p className="text-lg text-[#4A5043] max-w-2xl mx-auto">
              Experience these incredible benefits backed by clinical research
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div key={index} onClick={openModal} className="cursor-pointer">
              <div
                data-testid={`benefit-card-${index}`}
                className="bg-white rounded-2xl p-6 border-2 border-[#FFE4CC] hover:border-[#FF6B00] shadow-sm hover:shadow-xl transition-all duration-300 group h-full"
              >
                <div className="w-14 h-14 rounded-xl bg-[#FFF5E6] flex items-center justify-center mb-4 group-hover:scale-110 group-hover:bg-[#FF6B00] transition-all duration-300" aria-hidden="true">
                  <div className="group-hover:text-white transition-colors">{benefit.icon}</div>
                </div>
                <h3 className="text-lg font-bold text-[#1A1C19] mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                  {benefit.title}
                </h3>
                <p className="text-[#4A5043] text-sm leading-relaxed">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
